import filter from 'lodash/filter'
import groupBy from 'lodash/groupBy'
import map from 'lodash/map'
import { useMemo } from 'react'
import { calculateAvgPrice, parseData, stripQuarters } from './helperFunctions'
import type { CandleStickGraphData } from './typings'

export const useDataForCandleStickGraph = (
  region: string,
  data: CandleStickGraphData[],
  jsonKey: 'kauf' | 'miete'
) => {
  const preparedData = useMemo(() => {
    const parsedData = map(data, (yearData) => {
      return {
        name: yearData['name'],
        zeit: yearData['zeit'],
        avg_price: yearData[`mittl_preis_qm_${jsonKey}`],
        min_preis_qm: yearData[`min_preis_qm_${jsonKey}`],
        max_preis_qm: yearData[`max_preis_qm_${jsonKey}`],
      }
    })
    const filteredForRegion = filter(parsedData, (d) => d.name === region)
    const strippedQuarters = stripQuarters(filteredForRegion)
    const groupedByYear = groupBy(strippedQuarters, 'zeit')
    const avg_prices_per_year = calculateAvgPrice(groupedByYear, true)

    return avg_prices_per_year
  }, [data, jsonKey, region])

  const finalData = parseData(preparedData, true)
  return finalData
}
